import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitriseComponent } from './simple-icons-bitrise.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitriseComponent ],
    exports:      [ SimpleIconsBitriseComponent ],
    bootstrap:    []
})
export class SimpleIconsBitriseModule {}
